// extracted by mini-css-extract-plugin
export default {"cell":"styles_cell__IUwVL","meta":"styles_meta__LtbKN"};